import { StoreChips } from './store-chips.component';
import { StoresTable } from './stores-table.component';
import { ViewAll } from './view-all.component';

const STORE_CHIPS_LIMIT = 5;
const TABLE_STYLE = {
  minHeight: '30vh',
  maxHeight: '70vh',
  overflow: 'auto',
};

export const StoreChipsOrViewAll = ({
  label,
  description,
  ids,
  limit = STORE_CHIPS_LIMIT,
}: {
  label: string;
  description: string;
  ids: string[];
  limit?: number;
}) => {
  return ids.length > limit ? (
    <ViewAll
      label={label}
      description={description}
      count={ids.length}
      renderContent={(show) => (
        <StoresTable
          storeIds={ids}
          title={label}
          onClose={() => show(false)}
          tableSx={TABLE_STYLE}
        />
      )}
    />
  ) : (
    <StoreChips storeIds={ids} label={label} />
  );
};
